import { lazy } from 'react';

// project imports
import MainLayout from '../layout/MainLayout';
import Loadable from '../ui-component/Loadable';

// dashboard routing
const Dashboard = Loadable(lazy(() => import('../views/dashboard')));

// sample page routing
const AppContent = Loadable(lazy(() => import('../views/app-content')));
const AddApp = Loadable(lazy(() => import('../views/add-app')));
const AddCate = Loadable(lazy(() => import('../views/add-category')));
const AddContent = Loadable(lazy(() => import('../views/add-content')));
const EditContent = Loadable(lazy(() => import('../views/edit-content')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <Dashboard />,
        },
        {
            path: 'appdata/:appid',
            element: <AppContent />,
        },
        {
            path: 'addapp',
            element: <AddApp />,
        },
        {
            path: 'addcate',
            element: <AddCate />,
        },
        {
            path: 'addcontent/:appid',
            element: <AddContent />,
        },
        {
            path: 'editcontent/:dataid',
            element: <EditContent />,
        },
    ],
};

export default MainRoutes;
